import type { FC } from 'react';
import { TxStatus } from 'src/contract-types/Transactions';
import Label from 'src/components/Label';
import { IconButton, Tooltip, Zoom } from '@mui/material';

interface Props {
  entity: 'buyer' | 'seller',
  status: TxStatus,
  prefix?: string,
  suffix?: string,
}

const ItemStatusComponent: FC<Props> = ({ prefix, suffix, status, entity }: Props) => {
  const map = {
    pending: {
      color: 'warning',
      text: 'Pending',
    },
    approved: {
      color: 'primary',
      text: 'Approved',
    },
    dispute: {
      color: 'warning',
      text: 'In Dispute',
    },
    refunded: {
      color: 'success',
      text: 'Refunded',
    },
    complete: {
      color: 'success',
      text: 'Complete',
    },
  };

  const tooltipMap = {
    buyer: {
      pending: 'The transaction is pending the seller\'s approval. If it does not happen, you can always request a refund.',
      approved: 'The transaction is approved. Check the content and either dispute its integrity or give feedback to finish the transaction and get back your collateral.',
      dispute: 'The transaction is in dispute state. You should wait for it to be settled by the curators.',
      refunded: 'The transaction is refunded to you',
      complete: 'The transaction is complete',
    },
    seller: {
      pending: 'The transaction is pending your approval',
      approved: 'The transaction is approved',
      dispute: 'The transaction is in dispute state. You should wait for it to be settled by the curators.',
      refunded: 'The transaction is refunded to the buyer',
      complete: 'The transaction is complete',
    },
  };

  const { text, color }: any = map[status];

  return (
    <Tooltip
      title={tooltipMap[entity][status]}
      color={color}
      arrow
      placement="bottom-start"
      TransitionComponent={Zoom}
      sx={{ margin: 0, padding: 0 }}
    >
      <IconButton
        disableFocusRipple
        disableRipple
      >
        <Label
          color={color}
        >
          {prefix}
          {text}
          {suffix}
        </Label>
      </IconButton>
    </Tooltip>
  );
};

export default ItemStatusComponent;
